import {
  extractTimestamp,
  getImageUrl,
  getImageUrls,
  parseTimestamp,
} from "./imageUtils";
import React from "react";
import axios from "axios";
import { toast } from "../components/ui/use-toast";
export const getTourInfo = (tour) => {
  if (!Array.isArray(tour.images))
    return { newRooms: [], hotspots: [], startPoints: [] };

  // Sort tour.images by timestamp extracted from imageKey filename
  // debugger;
  const sortedImages = [...tour.images].sort((a, b) => {
    const fileNameA = a.imageKey.split("/").pop();
    const fileNameB = b.imageKey.split("/").pop();

    const aTimestamp = extractTimestamp(fileNameA);
    const bTimestamp = extractTimestamp(fileNameB);

    if (!aTimestamp || !bTimestamp) return 0;
    return parseTimestamp(aTimestamp) - parseTimestamp(bTimestamp);
  });

  // Map sorted images to structured room objects
  const newRooms = sortedImages.map((img, index) => ({
    ...img,
    imageKey: img.imageKey, // ✅ explicitly set for viewer compatibility
    thumbnailKey: img.imageKey.replace("/images/", "/thumbnails/"),
    // number: index + 1,
    name: img.name ? img.name : `Room ${index + 1}`,
    description: img.description ? img.description : `Room ${index + 1}`,
  }));
  // debugger;

  const hotspots = JSON.parse(JSON.stringify(tour?.hotspots ?? {}));
  const startPoints = JSON.parse(JSON.stringify(tour?.startPoints ?? {}));

  return { newRooms, hotspots, startPoints };
};

// export const getTourInfo = tour => {
//   let rooms = tour.photos || tour.images;
//
//   if (!tour.photos && tour.images) {
//     rooms = tour.images.map((img, index) => ({
//       number: index + 1,
//       name: `Room ${index + 1}`,
//       imageKey: img.imageKey,
//       description: `Room ${index + 1}`,
//       thumbnailKey: img.imageKey.replace('/images/', '/thumbnails/'),
//     }));
//     tour.photos = rooms; // this is just for consistent downstream logic
//   }
//   // Map rooms based on the available data (whether it's `photos` or `imageKeys`)
//   const newRooms = rooms.map((room, index) => ({
//     number: index + 1,
//     name: room.name,
//     thumbnailKey: room.imageKey.replace('/images/', '/thumbnails/'),
//     description: `Room ${index + 1}`,
//     imageKey: room.imageKey, // Assuming both formats have `imageKey`
//   }));
//
//   const { hotspots = [], startPoints = [] } = {
//     hotspots: tour?.hotspots ?? [],
//     startPoints: tour?.startPoints ?? [],
//   };
//   return { newRooms, hotspots, startPoints };
// };

// Helper function to get photo by room number
export const getPhotoByRoomNumber = (selectedProject, roomNumber) => {
  if (!selectedProject || !selectedProject.images) return null;
  return selectedProject.images[roomNumber - 1];
};

// Helper function to get current photo
export const getCurrentPhoto = (selectedProject, currentRoomId) => {
  if (!selectedProject || !selectedProject.images) return null;
  // debugger;
  const image = selectedProject.images.find((t) => t.id === currentRoomId);
  return image;
  // return selectedProject.images[currentRoom - 1];
};

// Load main image for current room
export const loadMainImage = async (selectedTour, currentRoomId) => {
  if (!selectedTour) return "";

  try {
    // if(selectedTour.imageKeys){
    //   return selectedTour.imageKeys;
    // }
    // debugger;
    const currentPhoto = getCurrentPhoto(selectedTour, currentRoomId);
    if (!currentPhoto) return "";

    const urls = await getImageUrls([currentPhoto.imageKey]);
    return urls[0].url;
  } catch (error) {
    console.error("Error loading main image:", error);
    return "";
  }
};
const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

// Load all thumbnails for current project
export const loadAllThumbnails = async (selectedProject, rooms) => {
  if (!selectedProject) return {};

  try {
    // const thumbnailPromises = rooms.map(async (room,index) => {
    //   const photo = getPhotoByRoomNumber(selectedProject, room.number);
    //   if (!photo || !photo.thumbnailKey) return null;
    //   // Add a delay between each request to prevent hitting the server too fast
    //   if (index > 0) {
    //     await delay(50); // 50ms delay between requests
    //   }
    //   const url = await getImageUrl(photo.thumbnailKey);
    //   return { roomNumber: room.number, url };
    // });

    const thumbnailKeys = rooms.map((room, index) => {
      // debugger;
      if (room.thumbnailKey) return room.thumbnailKey;
      const photo = getPhotoByRoomNumber(selectedProject, room.number);
      if (!photo || !photo.thumbnailKey) return null;
      return photo.thumbnailKey;
    });
    // debugger;
    const results = await getImageUrls(thumbnailKeys);
    const thumbnailsUrl = results.reduce((acc, result) => {
      if (result) {
        acc[result.key] = result.url;
      }
      return acc;
    }, {});
    // debugger;
    return thumbnailsUrl;
    // debugger;
  } catch (error) {
    console.error("Error loading thumbnails:", error);
    return {};
  }
};
export const getRoomInfo = (rooms, currentRoomId) => {
  return rooms.find((room) => room.id === currentRoomId);
};
export const renderHotspotStartpointDiv = (
  rooms,
  hotspots,
  startPoints,
  handleRoomChange,
  thumbnailUrls,
  currentRoomId,
  viewerMode = false,
) => {
  return (
    <>
      {rooms.map((room) => {
        const isActive = room.id === currentRoomId;
        // debugger;
        const hotspotCount = hotspots[room.id]?.length || [].length;
        const hasStartPoint = Boolean(startPoints[room.id]);

        return (
          <div
            key={room.id}
            className={`flex flex-col gap-1 p-4 border rounded cursor-pointer ${
              isActive ? "bg-blue-100 ring-2 ring-blue-500" : "bg-white"
            }`}
            onClick={() => handleRoomChange(room.id)}
          >
            {/*{currentRoomId}*/}
            <img
              src={thumbnailUrls[room.thumbnailKey] || ""}
              alt={room.name}
              className="w-24 h-16 object-cover"
            />
            <strong>{room.name}</strong>

            {!viewerMode && (
              <div>
                <div className="text-sm flex flex-col gap-1">
                  {hasStartPoint && (
                    <span className="text-green-600 font-semibold">
                      ✔️ Start Point Set
                    </span>
                  )}

                  <span className="text-gray-700">
                    🔥 Hotspots: {hotspotCount}
                  </span>
                </div>
              </div>
            )}
          </div>
        );
      })}
    </>
  );
};

export async function fetchWithRetry({
  url,
  data,
  retries = 3,
  delay = 1000,
  label = "",
  throwError = false,
}) {
  const token = localStorage.getItem("authToken");

  for (let i = 0; i < retries; i++) {
    try {
      const response = await axios.post(url, data, {
        headers: {
          "Content-Type": "application/json",
          ...(token && { Authorization: `Bearer ${token}` }),
        },
      });
      console.log(url, response);
      return response.data.result || response.data;
    } catch (error) {
      if (i === retries - 1) {
        console.error(`❌ ${label} failed after ${retries} attempts`, error);
        toast({
          title: `Error loading ${label}`,
          description: error.message,
          variant: "destructive",
        });
        if (throwError) {
          throw error;
        }
      } else {
        console.warn(`⚠️ ${label} with ${url} retry ${i + 1}...`);
        await new Promise((res) => setTimeout(res, delay));
      }
    }
  }
  return [];
}
export const loadingSpinner = () => {
  return (
    <div className="flex justify-center items-center h-32">
      <svg className="animate-spin h-6 w-6 text-gray-500" viewBox="0 0 24 24">
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
          fill="none"
        />
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8v8z"
        />
      </svg>
    </div>
  );
};
export const getTourTypeHebrew = (tourType) => {
  if (tourType == "TRUM_TICHNON") return "טרום תכנון";
  if (tourType == "TICHNON_VS_BITZUA") return "תכנון מול ביצוע";
  if (tourType == "TIUD_MESIRA") return "תיעוד מסירה";
  return "";
};
